<div>
  <!-- <div>
    <div class="cardHeading lato-bold-dark">Response Distribution • Lorem ipsum</div>
    <div class="cardDetails lato-regular">{{ doughnutChartGraphDetails }}</div>
    </div> -->
  <div class="doughnut-card-header">
    <div class="chartHeading">
      <div class="cardHeading lato-bold-dark">Response Distribution • {{ displayName }}</div>
      <div class="cardDetails lato-regular">{{ doughnutChartGraphDetails }}</div>
      <!-- <app-engagement-stackbar></app-engagement-stackbar> -->
    </div>
    <div class="cardFilter">
      <!-- <app-ltms-widget-tools></app-ltms-widget-tools> -->
      <app-ltms-widget-tools [config]='widgetConfig'></app-ltms-widget-tools>
    </div>
  </div>
  <div class="row row-cols-1 row-cols-md-3 cardchartsize" *ngIf="isDataLoaded; else loader">
    <div class="card" #deviceCard>
      <div class="card-title lato-bold-light">By device</div>
      <div class="card-body">
        <div class="chart">
          <app-ltms-doughnut-chart-view [chartData]="chartData" [elementId]="'by-device'"
            [colors]="devicebackgroundColor"></app-ltms-doughnut-chart-view>
        </div>
        <div *ngIf="chartData?.length">
          <div class="chartDataHolder" *ngIf="isTopData">
            <div class="chartDataHolderLabel">
              <div class="chartDataHolderLabelBarTop" [style.background-color]="devicebackgroundColor?.[0]"></div>
              <div class="chartDataHolderLabelName lato-regular">{{ topName }}</div>
            </div>
            <div class="attemptChartValue">
              <div class="attemptChartData lato-bold-dark">{{ topValue | indianNumberFormat }}</div>
              <div class="lato-bold-dark">({{ chartMobilePercentage }})</div>
            </div>
          </div>
          <div class="chartDataHolder" *ngIf="isMidData">
            <div class="chartDataHolderLabel">
              <div class="chartDataHolderLabelBarMid" [style.background-color]="devicebackgroundColor?.[1]"></div>
              <div class="chartDataHolderLabelName lato-regular">{{ midName }}</div>
            </div>
            <div class="attemptChartValue">
              <div class="attemptChartData lato-bold-dark">{{ midValue | indianNumberFormat }}</div>
              <div class="lato-bold-dark">({{ chartTabletPercentage }})</div>
            </div>
          </div>
          <div class="chartDataHolder" *ngIf="isBottomData">
            <div class="chartDataHolderLabel">
              <div class="chartDataHolderLabelBarBottom" [style.background-color]="devicebackgroundColor?.[2]"></div>
              <div class="chartDataHolderLabelName lato-regular">{{ bottomName }}</div>
            </div>
            <div class="attemptChartValue">
              <div class="attemptChartData lato-bold-dark">{{ bottomValue | indianNumberFormat }}</div>
              <div class="lato-bold-dark">({{ chartDesktopPercentage }})</div>
            </div>
          </div>
        </div>
        <!-- Message for unavailable data -->
        <div *ngIf="!isDataAvailable|| !chartData?.length" class="no-data-error-message">
          {{ dataUnavailableMessage }}
        </div>
      </div>
    </div>
    <div class="card" #channelCard>
      <div class="card-title lato-bold-light">By channels</div>
      <div class="card-body">
        <div class="chart">
          <app-ltms-doughnut-chart-view [chartData]="channelsData" [elementId]="'by-channel'"
            [colors]="channelbackgroundColor"></app-ltms-doughnut-chart-view>
        </div>
        <div class="attemptChartLevel">
          <div *ngFor="let item of this.channelData ; let i = index" class="chartDataHolder">
            <div class="attemptChartValue">
              <div [style.backgroundColor]="channelbackgroundColor[i]" class="color-box"></div>
              <div class="lato-regular">{{ item.name }}</div>
            </div>
            <div class="attemptChartValue">
              <div class="attemptChartData lato-bold-dark">{{ item.number_of_user_rated | indianNumberFormat }}</div>
              <div class="lato-bold-dark">({{ item.percentage }})</div>
            </div>
          </div>
        </div>
        <!-- Message for unavailable data -->
        <div *ngIf="!isDataAvailable || !channelData?.length" class="no-data-error-message">
          {{ dataUnavailableMessage }}
        </div>
      </div>
    </div>
    <div class="card" #attemptCard>
      <div class="card-title lato-bold-light">By attempts</div>
      <div class="card-body">
        <div class="chart">
          <app-ltms-doughnut-chart-view [chartData]="attemptschartData" [elementId]="'by-attempt'"
            [colors]="attemptbackgroundColor"></app-ltms-doughnut-chart-view>
        </div>
        <div class="attemptChartLevel">
          <div *ngFor="let item of attemptsData ; let i = index" class="chartDataHolder">
            <div class="attemptChartValue">
              <div [style.backgroundColor]="attemptbackgroundColor[i]" class="color-box"></div>
              <div class="lato-regular">{{ item.name }}</div>
            </div>
            <div class="attemptChartValue">
              <div class="attemptChartData lato-bold-dark">{{ item.number_of_user_rated | indianNumberFormat }}</div>
              <div class="lato-bold-dark">({{ item.percentage }})</div>
            </div>
          </div>
        </div>
        <!-- Message for unavailable data -->
        <div *ngIf="!isDataAvailable || !attemptsData?.length" class="no-data-error-message">
          {{ dataUnavailableMessage }}
        </div>
      </div>
    </div>
  </div>
  <ng-template #loader>
    <div class="data-loader">
      <app-ltms-loader></app-ltms-loader>
    </div>
  </ng-template> 
</div>